import videojs from 'video.js';
const VideoJsButtonClass = videojs.getComponent('MenuButton');
const VideoJsMenuClass = videojs.getComponent('Menu');
const VideoJsComponent = videojs.getComponent('Component');
const Dom = videojs.dom;
function toTitleCase(str) {
    if (typeof str !== 'string') {
        return str;
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
}
export default class ConcreteButton extends VideoJsButtonClass {
    items = [];
    hideThreshold_ = 0;
    constructor(player) {
        super(player, { title: player.localize('Quality') });
    }
    createItems() {
        return [];
    }
    createMenu() {
        const menu = new VideoJsMenuClass(this.player_, { menuButton: this });
        this.hideThreshold_ = 0;
        if (this.options_.title) {
            const titleEl = Dom.createEl('li', {
                className: 'vjs-menu-title',
                innerHTML: toTitleCase(this.options_.title),
                tabIndex: -1
            });
            const titleComponent = new VideoJsComponent(this.player_, { el: titleEl });
            this.hideThreshold_ += 1;
            menu.addItem(titleComponent);
        }
        this.items = this.createItems();
        if (this.items) {
            for (let i = 0; i < this.items.length; i++) {
                menu.addItem(this.items[i]);
            }
        }
        return menu;
    }
}
